import { GoogleLogin } from '@react-oauth/google';
import React from 'react';
import { jwtDecode } from 'jwt-decode';

interface GoogleLoginWrapperProps {
  onSuccess: (credentialResponse: any) => void;
}

interface GoogleUserInfo {
  email: string;
  name: string;
  picture: string;
  sub: string; // This will be used as providerId
}

const GoogleLoginWrapper: React.FC<GoogleLoginWrapperProps> = ({ onSuccess }) => {
  const handleSuccess = (credentialResponse: any) => {
    try {
      // Decode the JWT token to get user information
      const decodedToken = jwtDecode<GoogleUserInfo>(credentialResponse.credential);

      // Enhance the credential response with user data
      const enhancedResponse = {
        ...credentialResponse,
        userInfo: {
          email: decodedToken.email,
          name: decodedToken.name,
          profile: decodedToken.picture,
          providerId: decodedToken.sub,
        },
      };

      onSuccess(enhancedResponse);
    } catch (error) {
      console.error('Error decoding Google token:', error);
      onSuccess(credentialResponse); // Fall back to original response
    }
  };

  return (
    <div className="flex justify-center w-full mb-4">
      <GoogleLogin
        onSuccess={handleSuccess}
        onError={() => {
          console.log('Login Failed');
        }}
        useOneTap
        shape="rectangular"
        size="large"
        text="signin_with"
        width="100%"
        theme="outline"
      />
    </div>
  );
};

export default GoogleLoginWrapper;
